import React from 'react';
import './PaymentDrilldown.css';

/**
 * Pill-style breadcrumb trail for the claims drilldown. Takes the same
 * { label, level, onClick } shape PaymentHierarchy already builds.
 */
const DrilldownCrumbs = ({ breadcrumbs = [] }) => {
  if (!breadcrumbs.length) return null;

  return (
    <div className="drill-crumbs">
      {breadcrumbs.map((crumb, index) => {
        const isLast = index === breadcrumbs.length - 1;
        return (
          <React.Fragment key={`${crumb.level}-${index}`}>
            {index > 0 ? <span className="drill-crumb-sep">›</span> : null}
            <span
              className={`drill-crumb${isLast ? ' is-current' : ''}`}
              onClick={!isLast ? crumb.onClick : undefined}
              role={!isLast ? 'button' : undefined}
              tabIndex={!isLast ? 0 : undefined}
            >
              {crumb.label}
            </span>
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default DrilldownCrumbs;
